import React from 'react'
import { Container, GridRow, GridColumn, Button, Header, Modal, Grid, Label, Image } from 'semantic-ui-react'
import './PlayerPage.css'
import { connect } from 'react-redux'
import FormAnswer from './FormAnswer'
import FormTwoPlayers from './FormTwoPlayers'
import FormVotation from './FormVotation'
import FormMusic from './FormMusic'
import FormSevenWords from './FormSevenWords'
import { sendResult, voted,choiced, votedAMaggioranza } from '../reducers/result'
import soundUrlQuest from '../assets/000002.mp3'
import soundUrlRingtone from '../assets/000006.mp3'
import FormChoice from './FormChoice'
import {endGame, waitToEnd} from '../reducers/game'

const myPath = '../assets/';
//const myPath = '  http://s3.amazonaws.com/cicciolanciabucket/assets/';


const createDiceUrl = (number) => (
    myPath+""+number+".png"
 )



export class PlayerPage extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            msToAnswer: 20000,
            jump: 5000,
            result:0
        }
  
    }    

    handleAnswer = (result) =>{
        if (result == 0) result = 1;
        this.setState({result:result})
        this.props.onAnswer(this.state.result);
        if (this.props.gameType == 2) this.props.onWaitToEnd();
    }

    handleAnswerDummy = (result) =>{
    }

    handleChoice = (choiced) =>{
        this.props.onChoice(choiced);
      }
  

    handleVote = (vote) =>{
      this.props.onVoted(vote);
    }

    handleVoteAMaggioranza = (vote) =>{
        this.props.onVotedAMaggioranza(vote);
      }
  

    render() {
        const {gameType, result, user} = this.props
        const {msToAnswer,jump} = this.state
            switch(gameType){
                case 1:
                    return (
                        <Grid centered verticalAlign='middle' celled>
                        <GridRow centered>
                            <GridColumn centered>
                                <audio ref="audio_tag" src={soundUrlQuest} autoPlay/>
                                  <FormAnswer msToAnswer={msToAnswer} jump={jump} handleAnswer={this.handleAnswer} onGameEnded={this.props.onGameEnded} />
                            </GridColumn>
                        </GridRow>
                        </Grid>
                         )
                case 2:
                    return (
                        <Grid centered verticalAlign='middle' celled>
                        <GridRow centered>
                            <GridColumn centered>
                                <audio ref="audio_tag" src={soundUrlQuest} autoPlay/>
                                  <FormTwoPlayers msToAnswer={msToAnswer} jump={jump}  handleAnswer={this.handleAnswer} onGameEnded={this.props.onGameEnded} />
                            </GridColumn>
                        </GridRow>
                        </Grid>
                         )
                case 3:
                    return(
                        <Grid centered verticalAlign='middle' celled>
                        <GridRow centered>
                            <GridColumn centered>
                                <audio ref="audio_tag" src={soundUrlQuest} autoPlay/>
                                  <FormVotation msToAnswer={msToAnswer} jump={jump} handleVote={this.handleVote} handleAnswer={this.handleAnswerDummy} onGameEnded={this.props.onGameEnded} />
                            </GridColumn>
                        </GridRow>
                        </Grid>
                    )
                case 4:
                    return(
                        <Grid centered verticalAlign='middle' celled>
                        <GridRow centered>
                            <GridColumn centered>
                                    <FormMusic msToAnswer={msToAnswer} jump={jump} handleAnswer={this.handleAnswer} onGameEnded={this.props.onGameEnded} />
                            </GridColumn>
                        </GridRow>
                        </Grid>
                    )
                case 5:
                    return(
                        <Grid centered verticalAlign='middle' celled>
                        <GridRow centered>
                            <GridColumn centered>
                                <audio ref="audio_tag" src={soundUrlQuest} autoPlay/>
                                    <FormChoice msToAnswer={msToAnswer} jump={jump} handleChoice={this.handleChoice} handleAnswer={this.handleAnswerDummy} onGameEnded={this.props.onGameEnded} />
                            </GridColumn>
                        </GridRow>
                        </Grid>
                    )
                case 6:
                    return(
                        <Grid centered verticalAlign='middle' celled>
                        <GridRow centered>
                            <GridColumn centered>
                                <audio ref="audio_tag" src={soundUrlQuest} autoPlay/>
                                    <FormSevenWords msToAnswer={msToAnswer+10000} jump={jump} handleAnswer={this.handleAnswer} onGameEnded={this.props.onGameEnded} />
                            </GridColumn>
                        </GridRow>
                        </Grid>
                    )
                case 9:
                    return(
                        <Grid centered verticalAlign='middle' celled>
                        <GridRow centered>
                            <GridColumn centered>
                                <audio ref="audio_tag" src={soundUrlQuest} autoPlay/>
                                    <FormVotation msToAnswer={5000} jump={jump} handleVote={this.handleVoteAMaggioranza} handleAnswer={this.handleAnswerDummy} onGameEnded={this.props.onGameEnded} />
                            </GridColumn>
                        </GridRow>
                        </Grid>
                    )
                    default:
                    return (
                        <Grid centered verticalAlign='middle' celled>
                        <GridRow centered>
                            <GridColumn centered>
                            <Container textAlign='center'>
                                  <Header color='yellow' as='h2'>{'CIAO '+user.username.toUpperCase()}</Header> 
                            </Container>
                            
                            </GridColumn>
                        </GridRow>
                        <GridRow centered>
                            <GridColumn centered>
                            <Container textAlign='center'>
                                    {result!=0?<audio ref="audio_tag" src={soundUrlRingtone} autoPlay/>:""}
                                    <Grid centered celled>
                                    <GridRow >
                                    <GridColumn centered width={16}>
                                    <Container textAlign='center'>
                                        <img src={createDiceUrl(result)} width="200"/>
                                    </Container>
                                    </GridColumn>
                                    </GridRow>
                                   {(result!=0)?
                                    <GridRow >
                                    <GridColumn centered width={16}>
                                    <Container textAlign='center'>
                                    <Header color='red' as='h2'>Ora comunica a voce alta il risultato al master!</Header> 
                                    </Container>
                                    </GridColumn>
                                    </GridRow>
                                    :""}
                                    </Grid>
                            </Container>
                            </GridColumn>
                        </GridRow>
                        </Grid>
                         )
            }
    }
           
} 

const mapStateToProps = (state, { isLogged }) => ({
    state : state, 
    user: state.user,
    isLogged,
    launched: state.dice? state.dice.launched : false,
    question:state.game?state.game.question:undefined,
    gameType:state.game?state.game.gameType:0,
    result: state.result!=0?state.result.result:0
})

const mapDispatchToProps = (dispatch, { socket }) => ({
    onAnswer:(result)=>dispatch(sendResult(socket,result)),
    onVoted:(vote)=>dispatch(voted(socket,vote)),
    onVotedAMaggioranza:(vote)=>dispatch(votedAMaggioranza(socket,vote)),
    onChoice:(choice)=>dispatch(choiced(socket,choice)),
    onGameEnded:()=>dispatch(endGame({socket:socket})),
    onWaitToEnd:()=>dispatch(waitToEnd(socket))
})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PlayerPage)


// WEBPACK FOOTER //
// ./src/components/PlayerPage.js